// extracted by mini-css-extract-plugin
export default {"link":"TextLinkComponent_link__DuwRz","clickableLink":"TextLinkComponent_clickableLink__ltyZ7"};